import { createContext, ReactNode } from "react"
import { Domain } from "../domain"

export interface InnerContext {
  domain: Domain
}

window.domain =
  window.domain ??
  Domain.create({
    CHAIN_ID: import.meta.env.VITE_CHAIN_ID,
    GRAPHQL_URI: import.meta.env.VITE_GRAPHQL_URI,
    HW_PROJECT_ID: import.meta.env.VITE_HW_PROJECT_ID,
    VITE_OPENSEA_URL: import.meta.env.VITE_OPENSEA_URL,
  })

const innerContext: InnerContext = {
  domain: window.domain,
}

const Context = createContext<InnerContext>(innerContext)

interface DomainProviderProps {
  children: ReactNode
}

export const DomainContext = ({ children }: DomainProviderProps) => {
  return <Context.Provider value={innerContext}>{children}</Context.Provider>
}
